import { lazy, Suspense } from "react";
import { MOBILE_NAV_MENUS_ITEMS } from "./header-constants";
import { AccountValidation, UserMenus } from "./types";

// Lazy: account validation (incl. libphonenumber-js ~224 KiB source + search-autocomplete + fuse.js)
// is only shown to authenticated users with a pending validation.
const UserAccountValidation = lazy(() => import("./accountValidation"));

const ChevronRightIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="size-6 shrink-0">
    <path d="M9 6L15 12L9 18" stroke="#898994" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const MobileNavMenus = ({
  userData,
  accountValidationContent,
}: {
  userData: UserMenus;
  accountValidationContent: AccountValidation;
}) => {
  const getMobileMenuSvg = (menuTitle: string) => {
    switch (menuTitle) {
      case "Winners":
        return (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M8 21H16M12 17V21M12 17C13.3261 17 14.5979 16.4732 15.5355 15.5355C16.4732 14.5979 17 13.3261 17 12V4H7V12C7 13.3261 7.52678 14.5979 8.46447 15.5355C9.40215 16.4732 10.6739 17 12 17ZM3 9C3 9.53043 3.21071 10.0391 3.58579 10.4142C3.96086 10.7893 4.46957 11 5 11C5.53043 11 6.03914 10.7893 6.41421 10.4142C6.78929 10.0391 7 9.53043 7 9C7 8.46957 6.78929 7.96086 6.41421 7.58579C6.03914 7.21071 5.53043 7 5 7C4.46957 7 3.96086 7.21071 3.58579 7.58579C3.21071 7.96086 3 8.46957 3 9ZM17 9C17 9.53043 17.2107 10.0391 17.5858 10.4142C17.9609 10.7893 18.4696 11 19 11C19.5304 11 20.0391 10.7893 20.4142 10.4142C20.7893 10.0391 21 9.53043 21 9C21 8.46957 20.7893 7.96086 20.4142 7.58579C20.0391 7.21071 19.5304 7 19 7C18.4696 7 17.9609 7.21071 17.5858 7.58579C17.2107 7.96086 17 8.46957 17 9Z"
              stroke="#898994"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      case "Prize Collections":
        return (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M15.2787 13.1634C17.0905 14.9753 17.0905 17.9128 15.2787 19.7246C13.4669 21.5364 10.5294 21.5364 8.71756 19.7246C6.90574 17.9128 6.90574 14.9753 8.71756 13.1634C10.5294 11.3516 13.4669 11.3516 15.2787 13.1634"
              stroke="#898994"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M16.9318 7.537H7.06731"
              stroke="#898994"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M16.092 14.3041L20.3407 9.54109C20.7047 9.13359 20.9063 8.60585 20.9063 8.05918V5.31025C20.9063 4.08554 19.9042 3.0835 18.6795 3.0835H5.31895C4.08867 3.0835 3.0922 4.07997 3.0922 5.31025V8.05918C3.0922 8.60585 3.29372 9.13359 3.65779 9.54109L7.90645 14.3041"
              stroke="#898994"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M3.72717 3.78492L10.9753 11.9237"
              stroke="#898994"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M20.2716 3.78492L13.0235 11.9237"
              stroke="#898994"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      case "Customer Reviews":
        return (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M17.0036 8.08034V8.08034C17.3155 8.39224 17.4907 8.81527 17.4907 9.25637C17.4907 9.69746 17.3155 10.1205 17.0036 10.4324L15.4099 12.026C15.1661 12.2698 14.8355 12.4068 14.4907 12.4068C14.1459 12.4068 13.8153 12.2698 13.5715 12.026L11.9778 10.4324C11.6659 10.1205 11.4907 9.69743 11.4907 9.25634C11.4907 8.81524 11.6659 8.39221 11.9778 8.08031V8.08031C12.6273 7.43084 13.6803 7.43084 14.3298 8.08031L14.4907 8.24114L14.6515 8.08031C14.9634 7.7684 15.3864 7.59317 15.8275 7.59317C16.2686 7.59318 16.6917 7.76842 17.0036 8.08034V8.08034Z"
              stroke="#898994"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.507 18H18C19.6569 18 21 16.6569 21 15V6C21 4.34315 19.6569 3 18 3H6C4.34315 3 3 4.34315 3 6V15C3 16.6569 4.34315 18 6 18H8.007V20.4429C8.007 20.6567 8.12953 20.8515 8.3222 20.9441C8.51487 21.0367 8.74356 21.0107 8.91049 20.8771L12.507 18Z"
              stroke="#898994"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      case "How to play / FAQs":
        return (
          <svg width="24" height="24" viewBox="0 0 24.01 24.01" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M13.0059 20.943C12.6741 20.9841 12.3401 21.005 12.0059 21.005C7.0353 21.005 3.00586 16.9756 3.00586 12.005C3.00586 7.03444 7.0353 3.005 12.0059 3.005C16.9764 3.005 21.0059 7.03444 21.0059 12.005C21.0059 12.3393 20.985 12.6733 20.9439 13.005"
              stroke="#898994"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M20.0063 17.005L17.5063 19.505L16.0063 18.005"
              stroke="#898994"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M9.69057 9.6907C9.9275 8.66957 10.8575 7.96156 11.9049 8.00503C13.0771 7.9401 14.082 8.83333 14.1549 10.005C14.1549 11.5089 12.0049 12.005 12.0049 13.005"
              stroke="#898994"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12.1315 15.7554C12.1314 15.8244 12.0754 15.8803 12.0064 15.8803C11.9374 15.8803 11.8814 15.8243 11.8814 15.7553C11.8814 15.6863 11.9372 15.6303 12.0063 15.6302C12.0395 15.6301 12.0714 15.6433 12.0949 15.6668C12.1183 15.6903 12.1315 15.7222 12.1315 15.7554"
              stroke="#898994"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      case "Contact Us":
        return (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M14 18L18 21V18H19C20.105 18 21 17.105 21 16V10C21 8.895 20.105 8 19 8H11C9.895 8 9 8.895 9 10V16C9 17.105 9.895 18 11 18H14Z"
              stroke="#898994"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M9 15L6 17V14H5C3.895 14 3 13.105 3 12V6C3 4.895 3.895 4 5 4H14C15.105 4 16 4.895 16 6V8"
              stroke="#898994"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12.4304 12.9646C12.4499 12.9841 12.4499 13.0158 12.4304 13.0353C12.4109 13.0548 12.3792 13.0548 12.3597 13.0353C12.3402 13.0158 12.3402 12.9841 12.3597 12.9646C12.3792 12.9451 12.4109 12.9451 12.4304 12.9646"
              stroke="#898994"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M15.0354 12.9646C15.0549 12.9841 15.0549 13.0158 15.0354 13.0353C15.0159 13.0548 14.9842 13.0548 14.9647 13.0353C14.9452 13.0158 14.9452 12.9841 14.9647 12.9646C14.9842 12.9451 15.0159 12.9451 15.0354 12.9646"
              stroke="#898994"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M17.6404 12.9646C17.6599 12.9841 17.6599 13.0158 17.6404 13.0353C17.6209 13.0548 17.5892 13.0548 17.5697 13.0353C17.5502 13.0158 17.5502 12.9841 17.5697 12.9646C17.5892 12.9451 17.6209 12.9451 17.6404 12.9646"
              stroke="#898994"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      default:
        return null;
    }
  };

  return (
    <div className="flex flex-col gap-3 w-full min-w-0">
      <div className="text-xs font-jost font-medium leading-4 uppercase text-gray-1">Menu</div>
      <ul className="flex flex-col w-full bg-white rounded-lg overflow-hidden">
        {userData?.IsAuthenticated && userData?.ShouldShowAccountValidation && (
          <li className="w-full">
            <Suspense fallback={null}>
              <UserAccountValidation
                accountValidationContent={accountValidationContent}
                svgStroke="#F33424"
                variant="menuRow"
              />
            </Suspense>
          </li>
        )}

        {MOBILE_NAV_MENUS_ITEMS.map((competition, index) => {
          const isLast = index === MOBILE_NAV_MENUS_ITEMS.length - 1;

          return (
            <li key={competition.Title} className="w-full">
              <button
                type="button"
                onClick={() => {
                  location.href = competition.Url;
                }}
                className="flex items-center w-full h-14 px-4 gap-4 bg-white cursor-pointer text-left">
                <div className="relative size-6 shrink-0 overflow-clip">{getMobileMenuSvg(competition.Title)}</div>
                <div
                  className={`flex flex-1 items-center min-w-0 h-14 gap-2 ${
                    isLast ? "" : "border-b border-solid border-black/8"
                  }`}>
                  <span className="flex-1 min-w-0 text-base font-roboto font-normal leading-5.5 text-secondary break-words">
                    {competition.Title}
                  </span>
                  <ChevronRightIcon />
                </div>
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default MobileNavMenus;
